import { useConnections } from '../stores/connections.js'

class axiosPlugin {
    install(app) {
        app.config.globalProperties.axios = require('axios');
    }

    configure(appInstance) {
        const connectionsStore = useConnections();

        appInstance.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        appInstance.axios.defaults.withCredentials = true;
        appInstance.axios.interceptors.response.use(function(response) {
            // 200 OK
            return response;
        }, function (error) {
            /**
             * By Exception
             */
            const exception = error.response?.data.exception;
            if(exception !== undefined) {
                if(exception === 'App\\Exceptions\\FacebookAuthenticationException') {
                    appInstance.$alert({
                        type: 'danger',
                        title: this.$t('auth.facebook_auth_error_title'),
                        text: this.$t('auth.facebook_auth_error_text'),
                        cancelButton: null,
                        confirmButton: 'OK'
                    });
                    error.handled = true;
                    setTimeout(connectionsStore.refresh, 10);
                }
            }

            /**
             * By Status Code
             */
            if(error.response.status === 419) {
                // CSRF-token mismatch, alert user
                appInstance.$alert({
                    type: 'danger',
                    title: this.$t('auth.session_error_title'),
                    text: this.$t('auth.session_error_text'),
                    cancelButton: null,
                    confirmButton: 'OK'
                });
                error.handled = true;
            }
            const responseUrl = new URL(error.request.responseURL);
            if(
                error.response.status === 401
                && window.location.pathname !== '/'
                && responseUrl.pathname !== '/api/me'
                && window.location.pathname !== '/login'
            ) {
                // Unauthorized, reload the app
                window.location.reload();
                error.handled = true;
            }

            return Promise.reject(error);
        });
    }
}

export default new axiosPlugin
